import styles from 'components/light-box-login/index.module.scss';
import Lottie from 'react-lottie';
import animationData from 'images/mochiAnimation.json';
import React from 'react';
import { useLightBoxLoginContext } from 'components/light-box-login/use-light-box-login';
import classnames from 'classnames/bind';

const SuccessStep = () => {
  const cx = classnames.bind(styles);
  const { state } = useLightBoxLoginContext();

  const stepSuccessClass = cx({
    step: true,
    'step-success': true,
    in: state.successPageIn,
  });

  return (
    <div className={stepSuccessClass}>
      <div className={styles.title}>歡迎回來</div>
      <Lottie
        options={{
          loop: true,
          animationData: animationData,
          renderSettings: {
            preserveAspectRatio: 'xMidYMid slice',
          },
        }}
        isStopped={!state.successPageIn}
        height={334}
        width={400}
      />
    </div>
  );
};

export default SuccessStep;
